import { EntityType } from '~/enums/EntityType';
import {
  isLegacyPilotFieldId,
  isUfClientFieldId,
} from '~/features/fields/isLegacyPilotFieldId';
import {
  TargetEntity,
  TargetEntityDetails,
} from '~/features/x-ray/types/entity';

import { getClausesByIds } from '../../methods/clauses/getClausesByIds';
import { getClientFieldsByIds } from '../../methods/fields/getClientFieldsByIds';
import { getFields } from '../../methods/fields/getFields';

interface Request {
  entities: TargetEntity[];
}

export const resolvePromptModelTargetEntitiesDetails = async ({
  entities,
}: Request): Promise<Record<string, TargetEntityDetails>> => {
  const fieldEntities = entities.filter(
    (entity) => entity.type === EntityType.Field,
  );
  const legacyIds = [
    ...new Set(
      fieldEntities
        .filter((entity) => isLegacyPilotFieldId(entity.id))
        .map((entity) => Number(entity.id)),
    ),
  ];
  const ufIds = [
    ...new Set(
      fieldEntities
        .filter((entity) => isUfClientFieldId(entity.id))
        .map((entity) => entity.id),
    ),
  ];
  const clauseIds = [
    ...new Set(
      entities
        .filter((entity) => entity.type === EntityType.Clause)
        .map((entity) => entity.id),
    ),
  ];

  const [legacyFields, ufFields, clauses] = await Promise.all([
    legacyIds.length ? getFields({ ids: legacyIds }) : { results: [] },
    ufIds.length ? getClientFieldsByIds({ ids: ufIds }) : { results: [] },
    clauseIds.length ? getClausesByIds({ ids: clauseIds }) : { results: [] },
  ]);

  const detailsById: Record<string, TargetEntityDetails> = {};

  for (const field of legacyFields.results) {
    detailsById[String(field.id)] = {
      id: String(field.id),
      label: field.label,
      type: EntityType.Field,
      isSmart: field.isSmart,
    };
  }

  for (const field of ufFields.results) {
    detailsById[String(field.id)] = {
      id: String(field.id),
      label: field.label,
      type: EntityType.Field,
      isSmart: field.isSmart,
      fieldSourceDomain: field.fieldSourceDomain,
    };
  }

  for (const clause of clauses.results) {
    detailsById[clause.id] = {
      id: clause.id,
      label: clause.label,
      type: EntityType.Clause,
    };
  }

  return detailsById;
};
